// ─── Datos de contacto y enlaces ─────────────────────────────────────────────
export const CONTACT_PHONE = "+34 614 046 352";
export const CONTACT_EMAIL = "automatiza@ancoraautomations.es";
export const WHATSAPP_LINK = "https://wa.me/34614046352";
export const CALENDLY_LINK = "https://calendly.com/ancora-automations/consultoria";

// ─── Datos de la empresa ────────────────────────────────────────────────────
export const COMPANY_NAME = "Ancora Automations";

// ─── Logos ───────────────────────────────────────────────────────────────────
export const LOGO_LIGHT = "/logo-ancora-corporate.png?v=green";
export const LOGO_DARK = "/logo-ancora-corporate.png?v=green";

// ─── Nav sections ────────────────────────────────────────────────────────────
export const NAV_SECTIONS = [
  { label: "Servicios", href: "#que-hacemos" },
  { label: "Integraciones", href: "#integraciones" },
  { label: "Ventas IA", href: "#agentes-ventas" },
  { label: "Sectores", href: "#hosteleria" },
  { label: "Casos de éxito", href: "#casos" },
  { label: "Precios", href: "#pricing" },
  { label: "Blog", href: "/blog" },
];

// ─── Features (4 cards) ──────────────────────────────────────────────────────
export const FEATURES = [
  {
    title: "Atención IA en WhatsApp y voz",
    description:
      "Responde dudas, gestiona reservas, atiende llamadas y escala a tu equipo cuando hace falta, sin perder el contexto del cliente.",
    tags: ["WhatsApp", "Voz IA opcional"],
  },
  {
    title: "Marketing online conectado a tu operativa",
    description:
      "Publicaciones en Instagram y Google Business, campañas WhatsApp, reseñas y reactivación basadas en servicios y oportunidades reales.",
    tags: ["Instagram", "Google Business", "Campañas"],
  },
  {
    title: "Agenda y reservas conectadas",
    description:
      "Integramos tu calendario, CRM o software de reservas para confirmar disponibilidad, mover huecos y enviar recordatorios.",
    tags: [],
  },
  {
    title: "Agentes de ventas y seguimiento",
    description:
      "Detecta leads, cualifica interesados, propone la siguiente acción y mantiene visible cada oportunidad comercial.",
    tags: [],
  },
];

// ─── Sectores (3) ────────────────────────────────────────────────────────────
export const SECTORS = [
  {
    id: "hosteleria",
    label: "Hostelería",
    tagline: "Conecta consultas, reservas y reputación con la operativa diaria del local.",
    solutions: [
      {
        title: "Del menú del día al cliente",
        description:
          "Parte de la información que prepara el equipo, la adapta al canal acordado y deja la difusión lista para revisión o envío.",
        badge: "Entrada · contenido del negocio",
        path: "/integraciones-software-ia/",
      },
      {
        title: "De la petición a la reserva",
        description:
          "Recoge la solicitud, consulta la disponibilidad cuando la integración lo permite y confirma o deriva el siguiente paso.",
        badge: "Consulta · agenda",
        path: "/integraciones-software-ia/",
      },
      {
        title: "De la visita al seguimiento",
        description:
          "Solicita una valoración y prepara respuestas coherentes con el tono del negocio, manteniendo control humano cuando hace falta.",
        badge: "Seguimiento · reputación",
        path: "/agentes-ventas-ia/",
      },
    ],
  },
  {
    id: "salud",
    label: "Salud y belleza",
    tagline: "Haz avanzar la agenda y el seguimiento sin invadir decisiones clínicas o profesionales.",
    solutions: [
      {
        title: "De la consulta a la cita",
        description:
          "Aclara servicio y preferencias, consulta la agenda disponible y confirma la gestión dentro de las reglas del centro.",
        badge: "Acción · cita",
        path: "/clinicas-centros-agenda/",
      },
      {
        title: "Del cambio a un hueco útil",
        description:
          "Gestiona solicitudes de cambio o cancelación y aplica avisos o lista de espera según la configuración acordada.",
        badge: "Consulta · disponibilidad",
        path: "/centros-estetica-belleza/",
      },
      {
        title: "De la visita al próximo contacto",
        description:
          "Mantiene el seguimiento contextual y deriva al equipo cualquier recomendación que requiera criterio profesional.",
        badge: "Control · derivación humana",
        path: "/centros-estetica-belleza/",
      },
    ],
  },
  {
    id: "comercio",
    label: "Comercio y servicios",
    tagline: "Convierte preguntas y oportunidades en próximas acciones visibles para el equipo.",
    solutions: [
      {
        title: "De la pregunta a una respuesta útil",
        description:
          "Consulta catálogo, horarios o condiciones verificadas y responde sin inventar información que el negocio no haya validado.",
        badge: "Consulta · información real",
        path: "/integraciones-software-ia/",
      },
      {
        title: "Del interés al seguimiento comercial",
        description:
          "Recoge contexto, cualifica la oportunidad y mantiene la próxima acción visible hasta que el equipo decida intervenir.",
        badge: "Seguimiento · oportunidad",
        path: "/agentes-ventas-ia/",
      },
      {
        title: "Del aviso a la confirmación",
        description:
          "Prepara comunicaciones operativas por el canal acordado y registra su estado, con reglas y aprobaciones según alcance.",
        badge: "Ejecución · según alcance",
        path: "/agentes-ventas-ia/",
      },
    ],
  },
];

// ─── Marketing features (4) ──────────────────────────────────────────────────
export const MARKETING_FEATURES = [
  {
    title: "Instagram automático o asistido",
    description:
      "Posts, stories y reels/carruseles basados en tus servicios, temporada, promociones y huecos disponibles.",
    highlight: "Contenido con contexto real",
  },
  {
    title: "Google Business Profile",
    description:
      "Novedades, ofertas, publicaciones y respuestas a reseñas con enlaces a páginas concretas de la web.",
    highlight: "Más visibilidad local",
  },
  {
    title: "Reseñas y reputación",
    description:
      "Solicitudes post-visita, respuestas asistidas y seguimiento para mejorar confianza y conversión local.",
    highlight: "Confianza medible",
  },
  {
    title: "Campañas y reactivación",
    description:
      "Promos, huecos libres, clientes dormidos y seguimientos segmentados, siempre por módulos y con aprobación.",
    highlight: "Con alcance acordado",
  },
];

// ─── FAQ para sección de contacto (5 preguntas con tildes) ───────────────────
export const FAQS = [
  {
    question: "¿Necesito conocimientos técnicos para usarlo?",
    answer:
      "No, es lo opuesto. Nosotros nos encargamos de toda la configuración técnica, integración y puesta en marcha. Tú solo nos dices qué quieres que haga la IA y nosotros lo montamos.",
  },
  {
    question: "¿Cuánto tarda en estar funcionando?",
    answer:
      "Depende del proceso, los sistemas implicados y los permisos disponibles. Antes de empezar definimos el alcance, las pruebas y una implantación por fases.",
  },
  {
    question: "¿Qué pasa si la IA no sabe responder algo?",
    answer:
      "La IA está entrenada con la información de tu negocio. Si se encuentra con una pregunta que no sabe responder, puede transferir la conversación a un humano (a tu equipo) de forma transparente.",
  },
  {
    question: "¿Es seguro para los datos de mis clientes?",
    answer:
      "Revisamos qué datos necesita cada proceso, limitamos accesos y acordamos las medidas técnicas aplicables. El negocio mantiene la responsabilidad sobre sus tratamientos y decisiones profesionales.",
  },
  {
    question: "¿Puedo cancelar en cualquier momento?",
    answer:
      "Las condiciones de servicio, cancelación e implantación quedan definidas en la propuesta antes de empezar.",
  },
];

// ─── FAQ para sección de pricing ─────────────────────────────────────────────
export const FAQ_PRICING = [
  {
    question: "¿Qué significa «desde 9,99 €/mes»?",
    answer:
      "Es el precio del Agente WhatsApp Base. Incluye atención básica por WhatsApp, respuestas frecuentes, solicitudes de cita o reserva, recordatorios básicos, recogida de datos, configuración básica y un resumen simple. Integraciones, Instagram, campañas, voz y CRM avanzado se añaden aparte.",
  },
  {
    question: "¿Qué incluye la propuesta?",
    answer:
      "Definimos un primer proceso con sus canales, reglas, integraciones y supervisión. Voz, ventas, marketing u otros flujos se añaden por módulos cuando aportan valor.",
  },
  {
    question: "¿Necesito saber de tecnología?",
    answer:
      "No. Nosotros configuramos la IA, los canales y las integraciones. Tú sigues usando tus herramientas actuales y Ancora añade la capa operativa encima.",
  },
  {
    question: "¿Cómo se valora la implantación?",
    answer:
      "La implantación depende de los sistemas, permisos y pruebas que requiera el proceso. El alcance y cualquier coste asociado se detallan antes de empezar.",
  },
  {
    question: "¿Puedo añadir módulos más adelante?",
    answer:
      "Sí. Priorizamos un primer flujo y ampliamos por fases cuando existe una necesidad concreta y el equipo está preparado para validarlo.",
  },
  {
    question: "¿Qué pasa si cambia el alcance?",
    answer:
      "Revisamos el cambio contigo y actualizamos la propuesta antes de ejecutar trabajo adicional. No añadimos integraciones o capacidades sin acordar su alcance.",
  },
  {
    question: "¿Hay costes ocultos?",
    answer:
      "Te indicamos antes qué incluye cada módulo y qué queda fuera. Las integraciones, voz, campañas y desarrollos específicos se valoran según alcance.",
  },
  {
    question: "¿Y si mi negocio necesita algo distinto?",
    answer:
      "Estudiamos tu proceso y tu software para definir la conexión más útil. Las integraciones y las pruebas quedan detalladas en la propuesta.",
  },
];

// ─── Pasos de cómo funciona ─────────────────────────────────────────────────
export const HOW_IT_WORKS_STEPS = [
  {
    number: 1,
    title: "Consulta",
    description: "Revisamos el proceso y los sistemas implicados",
  },
  {
    number: 2,
    title: "Diseño",
    description: "Acordamos alcance, reglas, permisos y pruebas",
  },
  {
    number: 3,
    title: "Activación",
    description: "Conectamos y validamos el primer flujo por fases",
  },
  {
    number: 4,
    title: "Despegue",
    description: "Activamos lo validado y medimos antes de ampliar",
  },
];

// ─── Quiénes somos features ──────────────────────────────────────────────────
export const QUIENES_SOMOS_FEATURES = [
  {
    title: "Diagnóstico antes de construir",
    description: "Acordamos el proceso, los datos, los permisos y el resultado esperado antes de conectar sistemas.",
  },
  {
    title: "Implantación por fases",
    description: "Activamos primero el flujo prioritario, lo probamos y ampliamos solo cuando existe una necesidad clara.",
  },
  {
    title: "Control humano",
    description: "Las decisiones sensibles, excepciones y acciones que requieren criterio se derivan al equipo.",
  },
  {
    title: "Integraciones con alcance visible",
    description: "Analizamos el sistema actual, definimos la conexión y activamos cada capacidad por fases.",
  },
];

// ─── Casos de éxito ──────────────────────────────────────────────────────────
export const SUCCESS_STORIES = [
  {
    name: "Seven Sisters Tattoo",
    headline: "Consentimientos digitales y trazabilidad centralizada",
    headlineHighlight: "consentimientos digitales",
    headlineSuffix: "y trazabilidad centralizada",
    category: "Tattoo & Body Art",
    location: "Madrid",
    metric: "Documentación centralizada",
    description:
      "Raúl gestionaba su estudio en Madrid entre mensajes de WhatsApp, consentimientos en papel y reservas difíciles de seguir. Ahora reúne <strong>consentimientos, trazabilidad y recordatorios</strong> en un mismo flujo digital, con la documentación de cada sesión disponible para su revisión.",
    image: "/seven-sisters-exterior.jpg",
    images: ["/seven-sisters-exterior.jpg", "/seven-sisters-interior.jpg"],
    icon: "palette",
    badge: "Flujo documentado",
    since: "2024",
    quote:
      "Sabía que tenía que tener todo en regla, pero entre tatuar, atender mensajes y gestionar el local, los papeles siempre quedaban para después.",
    quoteAuthor: "Raúl, Seven Sisters Tattoo · Madrid",
    stats: [
      { value: "Digital", label: "Consentimientos" },
      { value: "Automático", label: "Recordatorios" },
      { value: "Central", label: "Trazabilidad" },
    ],
    features: [
      "Consentimientos digitales con firma electrónica",
      "Trazabilidad completa: tintas, agujas, fotos del material",
      "Recordatorios configurados alrededor de la cita",
      "Atención por WhatsApp e Instagram con derivación al equipo",
    ],
  },
  {
    name: "Consentirme",
    headline: "Treatwell, Booksy y WhatsApp coordinados",
    headlineHighlight: "Treatwell, Booksy y WhatsApp",
    headlineSuffix: "coordinados en el seguimiento",
    category: "Belleza & Bienestar",
    location: "Barajas, Madrid",
    metric: "Seguimiento multicanal",
    description:
      "Consentirme atiende reservas de belleza y bienestar desde varios canales. Áncora coordina <strong>conversación y seguimiento alrededor de Treatwell y Booksy</strong>, manteniendo visible el contexto para que el equipo valide cada gestión según el alcance disponible.",
    image: "/img/consentirme-treatwell-1.jpg",
    images: ["/img/consentirme-treatwell-1.jpg", "/img/consentirme-treatwell-2.jpg"],
    icon: "sparkles",
    badge: "Canales coordinados",
    since: "2026",
    quote:
      "El objetivo era no perder el contexto entre plataformas. Ahora conversación y seguimiento quedan coordinados para que el equipo pueda revisar cada gestión desde una operativa más clara.",
    quoteAuthor: "Guzmán, dueño de Consentirme Barajas · Madrid",
    stats: [
      { value: "Treatwell", label: "Reservas" },
      { value: "Booksy", label: "Reservas" },
      { value: "WhatsApp", label: "Seguimiento" },
    ],
    features: [
      "Coordinación de conversaciones alrededor de Treatwell y Booksy",
      "Consulta y confirmación configuradas para el flujo acordado",
      "Opt-in y campañas WhatsApp para clientes con consentimiento",
      "Seguimiento visible para el equipo y derivación cuando hace falta",
    ],
  },
];
